module.exports = "https://static.wagwalking.com/_next/static/images/pet-8-f844cfd57d56a853dc9a042f8f8a68ff.png";